import { useCallback, useEffect } from 'react';
import { TDynamicBalancesResponse } from 'js/hooks/socket/types';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when user balance is updated.
 * @memberOf Playtech.API.events
 * @event user:balanceUpdated
 * @example Playtech.on('user:balanceUpdated', () => { ... });
 */

export const EVENT_USER_BALANCE_UPDATED = 'user:balanceUpdated';

export const useOnUserBalanceUpdated = (eventTarget: EventTarget) => {
    const handleEvent = useCallback((response: TDynamicBalancesResponse): void => {
        const event = new CustomEvent(EVENT_USER_BALANCE_UPDATED, { detail: response });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('userBalanceUpdated', handleEvent);

        return () => publicEventsAPIService.off('userBalanceUpdated', handleEvent);
    }, [handleEvent]);
};
